module.exports = __webpack_public_path__ + "img/shenyang.49aa766a.png";